import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-map-wbs-payment',
  standalone:false,
  templateUrl: './map-wbs-payment.component.html',
})
export class MapWbsPaymentComponent implements OnInit{
 @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() id: any;
    private subscriptions = new Subscription();
   wbsVersions = [
    { version: 'V1.0', uploadDate: new Date('2025-08-01'), uploadedBy: 'Admin' },
    { version: 'V1.1', uploadDate: new Date('2025-08-10'), uploadedBy: 'Project Manager' },
  ];

  milestones = [
    { id: 1, name: 'Kickoff Meeting', start: new Date('2025-08-05'), end: new Date('2025-08-07'), status: 'Completed' },
    { id: 2, name: 'Prototype Development', start: new Date('2025-08-10'), end: new Date('2025-09-15'), status: 'Ongoing' },
    { id: 3, name: 'Testing & Review', start: new Date('2025-09-20'), end: new Date('2025-10-05'), status: 'Delayed' },
  ];

  payments = [
    { tranche: 'Tranche 1', milestone: 'Kickoff Meeting', percentage: 20, dueDate: '2025-08-07' },
    { tranche: 'Tranche 2', milestone: 'Prototype Development', percentage: 40, dueDate: '2025-09-15' },
    { tranche: 'Tranche 3', milestone: 'Testing & Review', percentage: 40, dueDate: '2025-10-05' },
  ];

 userID: any;


  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
   }
  ngOnInit(){
    this.getData()
  }
  onWbsUpload(event: any) {
    console.log('WBS file uploaded:', event);
    alert('Dummy parse: Milestones added successfully!');
  }

  viewWbs(v: any) {
    alert(`Viewing WBS ${v.version}`);
  }

  setActiveWbs(v: any) {
    alert(`WBS ${v.version} is now active.`);
  }

  savePayment(p: any) {
    console.log('Payment saved:', p);
    alert(`Payment for ${p.tranche} saved successfully!`);
  }

  deletePayment(p: any) {
    this.payments = this.payments.filter(item => item !== p);
    alert(`Payment for ${p.tranche} deleted!`);
  }
  
   getData() {

    const sub = this.api
      .getAPI(`/idex/milestone/?proposal_id=${this.proposalId}`)
      .subscribe({
        next: (res: any) => {
          this.milestones = res.map((m: any) => ({
          id: m.id,
          title: m.title,
          sub_deliverable:m.sub_deliverable,
          deliverable:m.deliverable,
          tranche: m.tranche,
          percentage: m.percentage,
          start_date: m.start_date,
          end_date: m.end_date,
          status: this.getStatus(m), // derive status
        }));
        },
        error: (err) => {},
      });
    this.subscriptions.add(sub);
  }
  getStatus(m: any): string {
  if (!m.start_date && !m.end_date) return '';
  const today = new Date().toISOString().split('T')[0];
  if (m.end_date && m.end_date < today) return 'Delayed';
  if (m.start_date && m.start_date <= today && (!m.end_date || m.end_date >= today)) return 'Ongoing';
  if (m.end_date && m.end_date >= today && m.percentage == '100.0') return 'Completed';
  return '';
}
saveMilestone(m: any) {
  const payload = {
    // id: m.id,
    proposal: m.proposal,
    title: m.title,
    sub_deliverable:m.sub_deliverable,
    deliverable:m.deliverable,
    tranche: m.tranche,
    percentage: m.percentage,
    start_date: m.start_date,
    end_date: m.end_date,
  };

  this.api.putAPI(`/idex/milestone/${m.id}/`, payload).subscribe({
    next: () => {
      this.getData();
      m.isEditMode = false;
    },
    error: (err) => console.error(err),
  });
}
deleteMilestone(m: any) {
  this.api.deleteAPI(`/idex/milestone/${m.id}/`).subscribe({
    next: () => {
      this.milestones = this.milestones.filter(x => x.id !== m.id);
      console.log('Deleted milestone', m.id);
    },
    error: (err) => console.error(err),
  });
}
}
